import { connect } from "react-redux";
import PropTypes from "prop-types";
import React from "react";
import i18n from "i18next";

import { SortedList } from "../Layout/SortedList";
import { checkIsInternalUser } from "../../helpers/Authorization/authorizationHelpers";
import ContactCard from "./ContactCard";
import ContactCardExternal from "./ContactCardExternal";
import FAQ from "./FAQ";
import Panel from "../Layout/Panel/Panel";
import PanelHeader from "../Layout/Panel/PanelHeader";
import UserManualCard from "./UserManualCard";
import PrivacyPolicyCard from "./PrivacyPolicyCard";
import TermsAndConditionsCard from "./TermsAndConditionsCard";

const isInternal = checkIsInternalUser();

const HelpPage = ({ isMobile }) => (
  <Panel className="help">
    <PanelHeader id={i18n.t("help.helpdeskSupport")} isMobile={isMobile} />
    <div className="help__container">
      <TermsAndConditionsCard />
      <PrivacyPolicyCard />
    </div>
    <div className="help__container">
      <UserManualCard isMobile={isMobile} />
      {isInternal ? <ContactCard /> : <ContactCardExternal />}
    </div>
    <div>
      <p className="faq__title">{i18n.t("faq.title")}</p>
      <SortedList
        RowComponent={FAQ}
        className="sorted-list__faq"
        data={i18n.t(isInternal ? "faq.questionsInternal" : "faq.questionsExternal", { returnObjects: true })}
        keyBy="question"
      />
    </div>
  </Panel>
);

HelpPage.propTypes = {
  isMobile: PropTypes.bool
};

HelpPage.defaultProps = {
  isMobile: false
};

const mapStateToProps = state => ({ isMobile: state.app.isMobile });

export default connect(
  mapStateToProps,
  {}
)(HelpPage);



// WEBPACK FOOTER //
// ./src/components/Help/HelpPage.js